import { render, staticRenderFns } from "./signedtochange.vue?vue&type=template&id=0bdb5c70&scoped=true"
import script from "./signedtochange.vue?vue&type=script&lang=js"
export * from "./signedtochange.vue?vue&type=script&lang=js"
import style0 from "./signedtochange.vue?vue&type=style&index=0&id=0bdb5c70&prod&lang=scss&scoped=true"
import style1 from "./signedtochange.vue?vue&type=style&index=1&id=0bdb5c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb5c70",
  null
  
)

export default component.exports